const API = {
  DEFAULT_TIMEOUT: 0,
  METHOD: {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    //DELETE: 'DELETE',
    //HEAD: 'HEAD'
  },
  RESPONSE_TYPE: {
    JSON: 'json',
    BLOB: 'blob',
    // ARRAYBUFFER: 'arraybuffer',
    // DOCUMENT: 'document',
    // TEXT: 'text',
    // STREAM: 'stream'
  },
  ERROR_TYPE: {
    API_ERROR: 'API_ERROR', //error code returned by API
    INVALID_RESPONSE: 'INVALID_RESPONSE', //error in parsing the response
    NOT_OK: 'NOT_OK', //service returned non-200 response
    CANCELLED: 'CANCELLED', //request was intentionally cancelled
    FAILED: 'FAILED', //no response received
    OTHER: 'OTHER' //unknown error
  }
};

export {
  API
};
